import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input } from "reactstrap";
import { Href } from "../../../../Constants/Constants";
import { ToDoAllData, ToDoDropdownData } from "../../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setDropdownData, setDropdownStates } from "../../../../ReduxToolkit/Reducers/Messenger/AppSidebar";

const AllTodo = () => {
  const dispatch = useAppDispatch();
  const { dropdownStates, dropdownData } = useAppSelector((state) => state.appSidebar);

  return (
    <div className="tab-card text-start">
      <div className="todo-task">
        <div className="todo-list">
          <div className="element" id="div_3">
            <span className="add add-to-do">Add-To-Do</span>
          </div>
        </div>
        {ToDoAllData.map((task, index) => (
          <div key={index} className="todo-main-content">
            <div className="input-text">
              <Input type="checkbox" />
            </div>
            <div>
              <h6>{task.title}</h6>
              <Dropdown className="currency" isOpen={dropdownStates[index]} toggle={() => dispatch(setDropdownStates(index))}>
                <div className="select">
                  <DropdownToggle tag="span" className="select">{dropdownData[index].dropdownData}</DropdownToggle>
                </div>
                <DropdownMenu>
                  <DropdownItem divider onClick={() => dispatch(setDropdownData({ index, data: "Assign To" }))}>
                    <div className="fa fa-user" />
                    <h5 className="text-muted">Assign To</h5>
                  </DropdownItem>
                  {ToDoDropdownData.map((item, i) => (
                    <DropdownItem onClick={() => dispatch(setDropdownData({ index, data: item }))} key={i}><a href={Href}>{item}</a></DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <Input className="datepicker-here digits" type="date" name="text" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllTodo;
